module.exports = __webpack_public_path__ + "img/join_resume02@2x.1bb3d0b0.png";